const React = require('react');
const TinyCart = require('./tiny-cart.jsx');
const ExpandCart = require('./expand-cart.jsx');
import Tinyremain from './tiny-remain.jsx';
const helper = require('../../../helper/dish-helper');
import './tiny-remain.scss';
import './pre-order.scss';
require('./cart.scss');

import { formatMessage } from '../../../intl/helper';
import commonMessage from '../../../intl/messages/common';
import orderText from '../../../intl/messages/order';

module.exports = React.createClass({
  displayName: 'CartContainer',
  propTypes: {
    shopInfo: React.PropTypes.object,
    dishes: React.PropTypes.array.isRequired,
    tinyRemainEnable: React.PropTypes.bool,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    onBillBtnTap: React.PropTypes.func.isRequired,
    onClearBtnTap: React.PropTypes.func.isRequired,
    toggleDishDescPopup: React.PropTypes.func.isRequired,
    takeawayServiceProps: React.PropTypes.object,
    openTimeList: React.PropTypes.array,
    isAcceptTakeaway: React.PropTypes.bool,
    urlType: React.PropTypes.string,
    isAcceptOrder: React.PropTypes.bool,
    wmCartImageUrl: React.PropTypes.string,
    tsCartImageUrl: React.PropTypes.string,
    dishesData: React.PropTypes.array,
    dishTypesData: React.PropTypes.array,
    changeShowDataItems: React.PropTypes.object,
    showHandleInput: React.PropTypes.func,
    onPropsBtnTap: React.PropTypes.func,
    getIsExpandCard: React.PropTypes.func,
    isShowSearch: React.PropTypes.bool,
    isDisableTinyRemain: React.PropTypes.bool,
    isHDL: React.PropTypes.bool,
    isMember: React.PropTypes.bool,
    ableAddPriceDiscount: React.PropTypes.bool,
    preOrderInfo: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.bool]),
    orderAgain: React.PropTypes.bool,
  },

  getInitialState() {
    return {
      expand: false,
      cartOrderedListHeight: { bottom: 49 },
      totalDishes: [],
      showItemReduce: true,
      showPreOrder: true,
    };
  },

  getDefaultProps() {
    return {
      getIsExpandCard: () => {},
    };
  },

  componentWillMount() {
    window.addEventListener('hashchange', () => {
      if (location.hash === '' && this.state.expand) {
        // hash 为空的时候，同时关闭购物车层和菜品详情层
        this.setState({ expand: false });
        this.props.toggleDishDescPopup(undefined);
      }
    });
    this.marketList = [];
    this.marketFirst = [];
  },

  componentDidMount() {
    this.setCartState();
  },

  setCartState() {
    setTimeout(() => {
      this.setState({ showPreOrder: false });
    }, 3000);
    if (this.props.orderAgain) {
      this.setState({ expand: true });
    }
  },

  formatMultiMarketing(multiMarketing, orderedDishes) {
    const totalPrice = helper.getDishesPrice(orderedDishes);
    const filterMultiMarketing = [];

    if (multiMarketing && multiMarketing.length === 0) {
      return {
        list: [],
        first: [],
      };
    }

    if (multiMarketing && multiMarketing.length > 0) {
      multiMarketing.forEach(item => {
        if (item.applyProductType === 1 && this.includeDate(item)) {
          // 针对全部商品
          const obj = {
            consumeLimit: item.consumeLimit,
            type: item.type,
            reduce: item.reduce,
            discount: item.discount,
          };
          filterMultiMarketing.push(obj);
        }
      });
    }

    const getFinalReduce = (item, isTotalPrice) => {
      if (item.type === 1) {
        return item.reduce;
      } else if (item.type === 2) {
        if (isTotalPrice) {
          return (totalPrice - item.discount * totalPrice * 0.1).toFixed(2);
        }
        return (item.consumeLimit - item.discount * item.consumeLimit * 0.1).toFixed(2);
      }
    };

    const reduceRepeat = array => {
      const newArray = [];
      array.forEach(item => {
        if (!newArray.find(itemt => itemt.consumeLimit === item.consumeLimit)) {
          newArray.push(item);
        }
      });
      return newArray;
    };

    const sortMultiMarketing = filterMultiMarketing.sort((a, b) => {
      if (a.consumeLimit === b.consumeLimit) {
        const finalReduceA = getFinalReduce(a);
        const finalReduceB = getFinalReduce(b);
        return finalReduceB - finalReduceA;
      }
      return a.consumeLimit - b.consumeLimit;
    });

    const minSortFilterMultiMarketing = reduceRepeat(sortMultiMarketing.filter(item => totalPrice < item.consumeLimit)).slice(0, 3);

    const maxSortFilterMultiMarketing = reduceRepeat(sortMultiMarketing.filter(item => totalPrice >= item.consumeLimit));

    /* 此处计算一共优惠了多少钱 */
    const maxSortFilterMultiMarketingLength = maxSortFilterMultiMarketing.length;
    if (maxSortFilterMultiMarketingLength > 0) {
      this.alreadyReduce = getFinalReduce(maxSortFilterMultiMarketing[maxSortFilterMultiMarketingLength - 1], true);
    } else {
      this.alreadyReduce = 0;
    }

    this.marketList = minSortFilterMultiMarketing;
    this.marketFirst = minSortFilterMultiMarketing.slice(0, 1);
    return {
      list: minSortFilterMultiMarketing,
      first: minSortFilterMultiMarketing.slice(0, 1),
    };
  },
  includeDate(item) {
    const myDate = new Date();
    const periodStart = item.periodStart;
    let periodEnd = item.periodEnd;
    if (periodEnd === '00:00:00') {
      periodEnd = '23:59:59';
    }
    const weekdays = item.weekdays.split('');
    const week = myDate.getDay();
    const hours = myDate.getHours();
    const minutes = myDate.getMinutes();
    const seconds = myDate.getSeconds();
    const formatFunc = number => {
      if (number < 10) {
        return `0${number}`;
      }
      return number;
    };
    const myTimeFormat = `${formatFunc(hours)}:${formatFunc(minutes)}:${formatFunc(seconds)}`;
    if (weekdays[week] === '1' && myTimeFormat >= periodStart && myTimeFormat <= periodEnd) {
      return true;
    }
    return false;
  },

  componentWillReceiveProps(nextProps) {
    const { getIsExpandCard } = nextProps;

    if (nextProps.dishes) {
      const dishesCount = helper.getDishesCount(nextProps.dishes);
      if (!dishesCount) {
        this.showAddItemsFunc();
        getIsExpandCard(false);
      }
    }
  },

  onClearBtnTap() {
    const { onClearBtnTap, getIsExpandCard } = this.props;
    this.setState({ expand: !this.state.expand });
    this.setState({ showItemReduce: true });
    onClearBtnTap();
    getIsExpandCard(false);
  },

  expandCart(count) {
    const { getIsExpandCard } = this.props;

    if (count <= 0) {
      return false;
    }
    this.setState({ showItemReduce: false });

    if (this.state.expand) {
      this.showAddItemsFunc();
      getIsExpandCard(false);
    } else {
      this.setState({ expand: true });
      getIsExpandCard(true);
    }

    if (this.refs.Tinyremain) {
      this.refs.Tinyremain.hideAddItems(null, true); // 收起 Tinyremain 列表
    }
  },

  getCartOrderedListHeight(cartOrderedListHeight) {
    this.setState({ cartOrderedListStyle: { bottom: cartOrderedListHeight + 48, zIndex: 11 } });
  },

  showAddItemsFunc() {
    this.setState({ expand: false });
    this.setState({ cartOrderedListStyle: { bottom: 49 } });
  },
  showItemsReduce(bool) {
    this.setState({ showItemReduce: bool });
  },

  render() {
    const {
      shopInfo,
      dishes,
      takeawayServiceProps,
      onBillBtnTap,
      onOrderBtnTap,
      isAcceptTakeaway,
      urlType,
      isAcceptOrder,
      wmCartImageUrl,
      tsCartImageUrl,
      showHandleInput,
      dishesData,
      dishTypesData,
      changeShowDataItems,
      onPropsBtnTap,
      tinyRemainEnable,
      isShowSearch,
      isDisableTinyRemain,
      isHDL,
      isMember,
      theme,
      ableAddPriceDiscount,
      preOrderInfo,
    } = this.props;
    const { expand, cartOrderedListStyle, showPreOrder } = this.state;
    const orderedDishes = dishes;
    const dishesCount = helper.getDishesCount(orderedDishes);
    let isShopOpen;

    if (helper.getUrlParam('type') === 'WM' && isAcceptTakeaway) {
      isShopOpen = true;
    } else {
      isShopOpen = shopInfo.openStatus || false;
    }
    const isEnableShop = shopInfo.isEnableShop;
    // const formatMultiMarketing = this.formatMultiMarketing(shopInfo.multiMarketing, orderedDishes).first;
    let formatMultiMarketingPart = [];

    if (this.marketList && this.marketList.length > 0) {
      this.marketList.slice(0, 3).forEach((item, index) => {
        if (item.type === 1) {
          formatMultiMarketingPart.push(
            <span key={index}>
              {formatMessage(orderText.full)}
              <span className="tiny-remain-highlight">{item.consumeLimit}</span>
              {formatMessage(orderText.reduce)}
              {sessionStorage.getItem('currency')}
              <span>{item.reduce}</span>{' '}
            </span>,
          );
        } else {
          formatMultiMarketingPart.push(
            <span key={index}>
              {formatMessage(orderText.full)}
              <span className="tiny-remain-highlight">{item.consumeLimit} </span>
              {formatMessage(orderText.can)}
              <span>
                {' '}
                {item.discount} {formatMessage(commonMessage.commondiscount)}
              </span>{' '}
            </span>,
          );
        }
      });
    }

    // const filterDishesDataWithPrice = dishesData.filter(item => item.marketPrice <= 10);
    // this.getTinyRemainPart(formatMultiMarketing, helper.getDishesPrice(orderedDishes), showAddItems, filterDishesDataWithPrice);

    const isShowTinyRemainInner = this.state.showItemReduce && dishesCount === 0 && this.marketList && this.marketList.length > 0;
    const isShowTinyRemain = !isShowSearch && !isDisableTinyRemain;
    const bottom = isShowTinyRemain || isShowTinyRemainInner ? '90px' : '63px';
    return (
      <div className="cart-container">
        <TinyCart
          expand={expand}
          tinyRemainEnable={tinyRemainEnable}
          dishesCount={dishesCount}
          totalPrice={helper.getDishesPrice(orderedDishes)}
          // totalMemberPrice={helper.getDishesPrice(orderedDishes, null, true)}
          totalMemberPrice={helper.getMemberDishesPrice(orderedDishes, ableAddPriceDiscount)}
          takeawayServiceProps={takeawayServiceProps}
          isShopOpen={isShopOpen}
          urlType={urlType}
          isAcceptOrder={isAcceptOrder}
          isEnableShop={isEnableShop}
          wmCartImageUrl={wmCartImageUrl}
          tsCartImageUrl={tsCartImageUrl}
          onBillBtnTap={onBillBtnTap}
          onCartIconTap={this.expandCart}
          orderedDishes={orderedDishes}
          isHDL={isHDL}
          multiMarketing={shopInfo.multiMarketing}
          isMember={isMember}
          theme={theme}
        />
        {preOrderInfo && (
          <div className={`pre-order-box o-fz--14 o-ta--c ${showPreOrder ? '' : 'fade-out'}`} style={{ bottom, zIndex: 2 }}>
            <div className="pre-order-box-inner">{preOrderInfo.showMsg}</div>
          </div>
        )}
        {this.state.showItemReduce && dishesCount === 0 && this.marketList && this.marketList.length > 0 ? (
          <div className="tiny-remain o-fz--12 o-ta--c" style={{ bottom: '47px', zIndex: 2 }}>
            <div className="tiny-remain-inner">{formatMultiMarketingPart}</div>
          </div>
        ) : null}
        {!isShowSearch && !isDisableTinyRemain && (
          <Tinyremain
            isHDL={this.props.isHDL}
            totalPrice={helper.getDishesPrice(orderedDishes)}
            changeShowDataItems={changeShowDataItems}
            dishesData={dishesData}
            multiMarketing={shopInfo.multiMarketing}
            dishTypesData={dishTypesData}
            takeawayServiceProps={takeawayServiceProps}
            showHandleInput={showHandleInput}
            onOrderBtnTap={onOrderBtnTap}
            onPropsBtnTap={onPropsBtnTap}
            showAddItemsFunc={this.showAddItemsFunc}
            outerStyle={dishesCount ? cartOrderedListStyle : {}}
            ref="Tinyremain"
          />
        )}
        {expand && dishesCount > 0 ? (
          <ExpandCart
            isMember={isMember}
            ableAddPriceDiscount={ableAddPriceDiscount}
            isHDL={this.props.isHDL}
            dishesCount={dishesCount}
            orderedDishes={orderedDishes}
            onCartIconTap={this.expandCart}
            onOrderBtnTap={onOrderBtnTap}
            onClearBtnTap={this.onClearBtnTap}
            showHandleInput={showHandleInput}
            getCartOrderedListHeight={this.getCartOrderedListHeight}
            showItemsReduce={this.showItemsReduce}
          />
        ) : (
          false
        )}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/cart-container.jsx